import BasicLayout from '@/layouts/basic-layout'

const prefix = 'payment-application-'
export default {
  path: '/financial-manage/payment-application',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '付款申请管理'},
      component: () => import('@/pages/financial-manage/payment-application/index')
    },
    {
      path: 'detail-create',
      name: `${prefix}create`,
      auth: ['hidden'],
      meta: {title: '付款申请新增'},
      component: () => import('@/pages/financial-manage/payment-application/detail-create')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '付款申请编辑'},
      component: () => import('@/pages/financial-manage/payment-application/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '付款申请详情'},
      component: () => import('@/pages/financial-manage/payment-application/detail-view')
    }
  ]
}
